<!-- <IFA-header></IFA-header> -->
<div class="container" id="Optimum-wealth-home">
  <div class="row">
    <div class="col-12 pt-4 mt-70">
      <div class="d-flex flex-row">
        <div class="flex-fill">
          <div class="col-12">
            <div class="sb-tag sb-offerings mb-12">Investor Reviews</div>
            <h2 class="wealth-section-title mb-6">Hear What Our Clients Say</h2>
            <p class="wealth-section-description">
              Check out what our clients have to say about us.
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-12 col-xs-12 col-sm-12">
        <div class="PriCback">
          <div class="testimonial-quote group">
            <img [src]="Investorimg1" />
            <div class="quote-container">
              <blockquote>
                <p>{{ Hearclientsaypara1 }}</p>
              </blockquote>
              <cite>
                <span>{{ Investorname1 }}</span>
                <br />
                {{ InvestorDiscription1 }}
                <br />
              </cite>
            </div>
          </div>
        </div>
        <div class="SecCback">
          <div class="testimonial-quote group right">
            <img [src]="Investorimg2" />
            <div class="quote-container">
              <div>
                <blockquote>
                  <p>{{ Hearclientsaypara2 }}</p>
                </blockquote>
                <cite>
                  <span>{{ Investorname2 }}</span>
                  <br />
                  {{ InvestorDiscription2 }}
                  <br />
                </cite>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 col-xs-12 col-sm-12">
        <div class="PriCback">
          <div class="testimonial-quote group">
            <img [src]="Investorimg3" />
            <div class="quote-container">
              <blockquote>
                <p>{{ Hearclientsaypara3 }}</p>
              </blockquote>
              <cite>
                <span>{{ Investorname3 }}</span>
                <br />
                {{ InvestorDiscription3 }}
                <br />
              </cite>
            </div>
          </div>
        </div>
        <div class="SecCback">
          <div class="testimonial-quote group right">
            <img [src]="Investorimg4" />
            <div class="quote-container">
              <div>
                <blockquote>
                  <p>{{ Hearclientsaypara4 }}</p>
                </blockquote>
                <cite>
                  <span>{{ Investorname4 }}</span>
                  <br />
                  {{ InvestorDiscription4 }}
                  <br />
                </cite>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-xs-12 col-sm-12">
        <div class="PriCback">
          <div class="testimonial-quote group">
            <img [src]="Investorimg5" />
            <div class="quote-container">
              <blockquote>
                <p>{{ Hearclientsaypara5 }}</p>
              </blockquote>
              <cite>
                <span>{{ Investorname5 }}</span>
                <br />
                {{ InvestorDiscription5 }}
                <br />
              </cite>
            </div>
          </div>
        </div>
        <!-- <div class="SecCback">

        <div class="testimonial-quote group right">
          <img src="../../assets/images/img/testimonial/Frame 803.svg">
          <div class="quote-container">
            <div>
              <blockquote>
                <p>{{Hearclientsaypara4}}</p>
              </blockquote>
              <cite><span>{{Investorname4}}</span><br>
                {{InvestorDiscription4}}<br>

              </cite>
            </div>
          </div>
        </div>
      </div> -->
      </div>
    </div>
  </div>
</div>

<IFA-footer></IFA-footer>
